import { execAdminForm } from '../utils';

interface ScheduleCatalogUploadVariables {
  partnerCode: string;
  source?: string;
  sourcePartnerCode?: string;
  useExistingUpload?: boolean;
  scheduledAt?: string;
  timezone?: string;
  totalRowCount?: number;
}

interface ScheduleCatalogUploadResponse {
  scheduleCatalogUpload: {
    id: number;
    location: string;
    partnerCode: string;
  };
}

const SCHEDULE_CATALOG_UPLOAD_MUTATION = `
  mutation scheduleCatalogUpload(
    $partnerCode: String
    $source: String
    $sourcePartnerCode: String
    $useExistingUpload: Boolean
    $scheduledAt: String
    $timezone: String
    $totalRowCount: Int
  ) {
    scheduleCatalogUpload(
      partnerCode: $partnerCode
      source: $source
      sourcePartnerCode: $sourcePartnerCode
      useExistingUpload: $useExistingUpload
      scheduledAt: $scheduledAt
      timezone: $timezone
      totalRowCount: $totalRowCount
    ) {
      id
      location
      partnerCode
    }
  }
`;

export const scheduleCatalogUpload = async (
  variables: ScheduleCatalogUploadVariables,
  file: File,
): Promise<ScheduleCatalogUploadResponse> => {
  return execAdminForm<ScheduleCatalogUploadVariables, ScheduleCatalogUploadResponse>(
    SCHEDULE_CATALOG_UPLOAD_MUTATION,
    variables,
    { file },
  );
};
